import * as React from 'react';
import {connect} from 'react-redux';
import * as selectors from '../selectors';
import DownloadState from '../DownloadState';
import {Form, Checkbox} from 'react-bootstrap';
import {Operation} from '../../../../integration/representation/feature';
import {
    setOperations,
    SetOperations
} from '../actions';

interface TagProps {
}

interface DispatchProps {
    doSetOperation: SetOperations;
}

interface StateProps {
    validOperations: Set<Operation>;
    operations: Operation[];
}

type Props = TagProps & StateProps & DispatchProps;

const mapStateToProps = (state: DownloadState): StateProps => {
    return {
        operations: selectors.operations(state),
        validOperations: selectors.validOperations(state)
    };
};

const mapDispatchToProps: DispatchProps = ({
    doSetOperation: setOperations
});

const possibleCheckboxes: {value: Operation, text: string}[] = [
    {
        value: 'CREATE',
        text: 'Opprett'
    },
    {
        value: 'CORRECT',
        text: 'Korriger'
    },
    {
        value: 'UPDATE',
        text: 'Oppdater'
    },
    {
        value: 'CLOSE',
        text: 'Lukk'
    }
];


class Component extends React.Component<Props, {}> {

    handleOperationChange(operation: Operation) {
        const newOperations = (this.props.operations.includes(operation)
            ? this.props.operations.filter(op => op !== operation)
            : this.props.operations.concat(operation))
            .filter((op, i, arr) => arr.indexOf(op) === i);
        this.props.doSetOperation(newOperations);
    }

    render() {
        const { operations, validOperations } = this.props;

        return (
            <div className={'download-selection-box'}>
                <h2>Operasjon</h2>
                <p>Jeg vil laste ned SOSI-fil med objekter som har operasjon:</p>
                <Form>
                    {
                        possibleCheckboxes.map(({value, text}) => {
                            const disabled = !validOperations.has(value);
                            const checked = operations.includes(value);
                            const onChange = () => this.handleOperationChange(value);
                            return (
                                <span key={value} title={disabled ? 'Ingen objekter av denne typen' : ''}>
                                    <Checkbox disabled={disabled} checked={checked} onChange={onChange}>{text}</Checkbox>
                                </span>
                            );
                        })
                    }
                </Form>
            </div>
        );
    }
}

export const OperationSelection = connect(mapStateToProps, mapDispatchToProps)(Component);
